<form #honorForm="ngForm" class="honor-form">
  <section class="honor-card cmnh-card simple">
    <div class="card-body">
      <div class="honor-content">
        <div class="honor-choice-group">
          <app-cmn-selector [checked]="inMemoryHonorOf" [label]="'SPLASH_IN_MEMORY_1' | translate"
            [description]="'SPLASH_IN_MEMORY_2' | translate" ariaLabel="Toggle in memory or honor gift"
            (toggled)="inMemoryHonorOf=!inMemoryHonorOf"></app-cmn-selector>
        </div>

        <!-- hasErrors: {{hasErrors}} -->

        @if (inMemoryHonorOf) {
        <section class="honor-panel">
          <div class="honor-choice-grid">
            <div class="honor-choice-group">
              <app-cmn-selector [checked]="inHonor" [label]="'IN_HONOR' | translate" ariaLabel="Toggle in honor"
                (toggled)="inHonor=!inHonor;inMemory=false;"></app-cmn-selector>
            </div>
            <div class="honor-choice-group">
              <app-cmn-selector [checked]="inMemory" [label]="'IN_MEMORY' | translate" ariaLabel="Toggle in memory"
                (toggled)="inMemory=!inMemory;inHonor=false"></app-cmn-selector>
            </div>
          </div>
          <div class="honor-field honor-field--full"
            [class.honor-field--valid]="showError(inhonorname) && inhonorname.valid"
            [class.honor-field--invalid]="showError(inhonorname) && inhonorname.invalid">
            <app-cmn-input [label]="'IN_HONOR_NAME' | translate" inputId="inhonorname" name="inhonorname" type="text"
              autocomplete="section-honor name" required maxlength="50" #inhonorname="ngModel"
              [(ngModel)]="honorModel.inHonorName" [control]="inhonorname" [showError]="showError(inhonorname)"></app-cmn-input>
          </div>
        </section>
        }

        <div class="honor-divider"></div>

        <div class="honor-choice-group">
          <app-cmn-selector [checked]="notifySomeone" [label]="'NOTIFY' | translate" ariaLabel="Toggle notify someone"
            (toggled)="notifySomeone=!notifySomeone"></app-cmn-selector>
        </div>

        @if (notifySomeone) {
        <section class="notify-section">
          <div class="honor-grid">
            <div class="honor-field" [class.honor-field--valid]="showError(notifyname) && notifyname.valid"
              [class.honor-field--invalid]="showError(notifyname) && notifyname.invalid">
              <app-cmn-input [label]="'NOTIFY_NAME' | translate" inputId="notifyname" name="notifyname" type="text"
                autocomplete="section-notify name" required maxlength="50" #notifyname="ngModel"
                [(ngModel)]="giftNotify.notifyName" [control]="notifyname" [showError]="showError(notifyname)"></app-cmn-input>
            </div>
            <div class="honor-field" [class.honor-field--valid]="showError(notifyemail) && notifyemail.valid"
              [class.honor-field--invalid]="showError(notifyemail) && notifyemail.invalid">
              <app-cmn-input [label]="'EMAIL' | translate" inputId="notifyemail" name="notifyemail" type="email"
                autocomplete="section-notify email" email required maxlength="128" #notifyemail="ngModel"
                [(ngModel)]="giftNotify.email" [control]="notifyemail" [showError]="showError(notifyemail)"></app-cmn-input>
            </div>
            <div class="honor-field" [class.honor-field--valid]="showError(notifytelephone) && notifytelephone.valid"
              [class.honor-field--invalid]="showError(notifytelephone) && notifytelephone.invalid">
              <app-cmn-input [label]="'TELEPHONE' | translate" inputId="notifytelephone" name="notifytelephone"
                type="tel" autocomplete="section-notify tel" required minlength="7" maxlength="14" pattern="^[0-9]+$"
                #notifytelephone="ngModel" [(ngModel)]="giftNotify.telephone" [control]="notifytelephone"
                [showError]="showError(notifytelephone)" [showMaxlengthReached]="
                notifytelephone.value?.length === 14 &&
                (notifytelephone.dirty || notifytelephone.touched)
              " [minlengthMessage]="'VALIDATION_PHONE_MIN_LENGTH' | translate"
                [patternMessage]="'VALIDATION_NUMBERS_ONLY' | translate"></app-cmn-input>
            </div>
            <div class="honor-field" [class.honor-field--valid]="showError(postalCodeNotify) && postalCodeNotify.valid"
              [class.honor-field--invalid]="showError(postalCodeNotify) && postalCodeNotify.invalid">

              <app-cmn-input [label]="'POSTAL_CODE' | translate" inputId="postalCodeNotify" name="postalCodeNotify"
                type="text" autocomplete="section-notify postal-code" searchIcon
                [loading]="donorEditCommon.lookingUpZip" required maxlength="15" #postalCodeNotify="ngModel"
                [(ngModel)]="giftNotify.postalCode" [control]="postalCodeNotify"
                [showError]="showError(postalCodeNotify)"
                (inputBlur)="donorEditCommon.lookUpZipBlur(giftNotify.postalCode, giftNotify)"></app-cmn-input>
            </div>
            <div class="honor-field honor-field--full"
              [class.honor-field--valid]="showError(notifyaddress1) && notifyaddress1.valid"
              [class.honor-field--invalid]="showError(notifyaddress1) && notifyaddress1.invalid">
              <app-cmn-input [label]="'ADDRESS_1' | translate" inputId="notifyaddress1" name="notifyaddress1"
                type="text" autocomplete="section-notify address-line1" required maxlength="50"
                #notifyaddress1="ngModel" [(ngModel)]="giftNotify.address1" [control]="notifyaddress1"
                [showError]="showError(notifyaddress1)"></app-cmn-input>
            </div>
            <div class="honor-field honor-field--full"
              [class.honor-field--valid]="showError(notifyaddress2) && notifyaddress2.valid"
              [class.honor-field--invalid]="showError(notifyaddress2) && notifyaddress2.invalid">
              <app-cmn-input [label]="'ADDRESS_2' | translate" inputId="notifyaddress2" name="notifyaddress2"
                type="text" autocomplete="section-notify address-line2" maxlength="50" #notifyaddress2="ngModel"
                [(ngModel)]="giftNotify.address2" [control]="notifyaddress2"
                [showError]="showError(notifyaddress2)"></app-cmn-input>
            </div>
            <div class="honor-field" [class.honor-field--valid]="showError(notifycity) && notifycity.valid"
              [class.honor-field--invalid]="showError(notifycity) && notifycity.invalid">
              <app-cmn-input [label]="'CITY' | translate" inputId="notifycity" name="notifycity" type="text"
                autocomplete="section-notify address-level2" required maxlength="50" #notifycity="ngModel"
                [(ngModel)]="giftNotify.city" [control]="notifycity" [showError]="showError(notifycity)"></app-cmn-input>
            </div>
            <div class="honor-field" [class.honor-field--valid]="showError(notifystateId) && notifystateId.valid"
              [class.honor-field--invalid]="showError(notifystateId) && notifystateId.invalid">
              <label class="cmnh-select-label honor-label" for="notifystateId">
                {{ "STATE" | translate }}<span class="required-field">*</span>
              </label>
              <select name="notifystateId" id="notifystateId" autocomplete="section-notify address-level1"
                #notifystateId="ngModel" [(ngModel)]="giftNotify.stateId" class="cmnh-select honor-control honor-select"
                required>
                <option class="cmnh-select-option" value="">
                  --Select State--
                </option>

                @for (ctype of donorEditCommon.states; track ctype) {
                <option class="cmnh-select-option" [ngValue]="ctype.value">
                  {{ ctype.label }}
                </option>
                }
              </select>
              @if (notifystateId.invalid && showError(notifystateId)) {
              <span class="honor-error">
                {{ "THIS_FIELD_IS_REQUIRED" | translate }}
              </span>
              }
            </div>
          </div>
        </section>
        }

        <div class="honor-divider"></div>
        <app-planned-giving [plannedGiving]="plannedGiving" [form]="form"
          [donorPhone]="donorEditCommon?.donor?.telephone" [donorEmail]="donorEditCommon?.donor?.email">
        </app-planned-giving>
      </div>
    </div>
  </section>
</form>
